export default "b46878673765f89281dfdaafc68d6f37.png";